import * as React from "react";
import { singleton } from "logic/singleton";
const FormDataContext = React.createContext(void 0);
export default singleton("contexts.integrations.FormDataContext", () => FormDataContext);
